export default __webpack_public_path__ + "static/media/stp-icon.9cc4f264.svg";